import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-2b5ce83c")
const _hoisted_1 = { class: "container mx-auto pt-10 md:pt-12" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "flex mb-3 items-center",
  style: {"font-size":"28px"}
}, [
  /*#__PURE__*/_createElementVNode("h3", null, "Swap")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-1 invest-farm-separator" }, null, -1)
const _hoisted_4 = { class: "hidden lg:block" }
const _hoisted_5 = { class: "flex justify-center items-start gap-8 mt-8" }
const _hoisted_6 = { class: "w-[520px]" }
const _hoisted_7 = { class: "w-[520px] sticky top-8" }
const _hoisted_8 = { class: "lg:hidden mt-8" }
const _hoisted_9 = { class: "flex flex-col items-center" }
const _hoisted_10 = { class: "w-full max-w-[520px] px-4" }
const _hoisted_11 = { class: "w-full max-w-[520px] px-4 mt-8" }
_popScopeId()

import { computed, onMounted, ref } from 'vue';
import { ENABLE_LEGACY_TRADE_INTERFACE } from '@/composables/trade/constants';
// Types
import { TradeInterface } from '@/store/modules/app';
// Composables
import { useStore } from 'vuex';
import useBreakpoints from '@/composables/useBreakpoints';
import useTokenLists from '@/composables/useTokenLists';
import usePoolFilters from '@/composables/pools/usePoolFilters';
// Components
import TradeCard from '@/embr/components/pages/trade/TradeCard.vue';
import TradeCardGP from '@/components/cards/TradeCardGP/TradeCardGP.vue';
import Col2Layout from '@/components/layouts/Col2Layout.vue';
import TradeSmartRouter from '@/embr/components/pages/trade/TradeSmartRouter.vue';
import TradeCardResponsive from '../components/pages/trade/TradeCardResponsive.vue';
import { scrambleCategories } from '@/embr/utils/AnimationTitle.js';
/**
 * STATE
 */

export default _defineComponent({
  setup(__props) {

const showPriceGraphModal = ref(false);

/**
 * COMPOSABLES
 */
const store = useStore();
const { loadingTokenLists } = useTokenLists();
const { setSelectedTokens } = usePoolFilters();
const { upToLargeBreakpoint } = useBreakpoints();

/**
 * COMPUTED
 */
const appLoading = computed(() => store.state.app.loading);
const tradeInterface = computed(() => store.state.app.tradeInterface);

/**
 * METHODS
 */
function onPriceGraphModalClose() {
  showPriceGraphModal.value = false;
}

function togglePairPriceGraphModal() {
  showPriceGraphModal.value = !showPriceGraphModal.value;
}

/**
 * CALLBACKS
 */
onMounted(() => {
  // selectedPoolTokens are only persisted between the Home/Pool pages
  setSelectedTokens([]);
  scrambleCategories();
});

return (_ctx: any,_cache: any) => {
  const _component_BalLoadingBlock = _resolveComponent("BalLoadingBlock")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_unref(appLoading) || _unref(loadingTokenLists))
            ? (_openBlock(), _createBlock(_component_BalLoadingBlock, {
                key: 0,
                class: "h-96"
              }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_unref(ENABLE_LEGACY_TRADE_INTERFACE))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_unref(tradeInterface) === _unref(TradeInterface).BALANCER)
                        ? (_openBlock(), _createBlock(TradeCard, { key: 0 }))
                        : (_unref(tradeInterface) === _unref(TradeInterface).GNOSIS)
                          ? (_openBlock(), _createBlock(TradeCardGP, { key: 1 }))
                          : _createCommentVNode("", true)
                    ], 64))
                  : (_openBlock(), _createBlock(TradeCardGP, { key: 1 }))
              ], 64))
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(TradeSmartRouter)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          (_unref(appLoading) || _unref(loadingTokenLists))
            ? (_openBlock(), _createBlock(_component_BalLoadingBlock, {
                key: 0,
                class: "h-96"
              }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_unref(ENABLE_LEGACY_TRADE_INTERFACE))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_unref(tradeInterface) === _unref(TradeInterface).BALANCER)
                        ? (_openBlock(), _createBlock(TradeCardResponsive, { key: 0 }))
                        : (_unref(tradeInterface) === _unref(TradeInterface).GNOSIS)
                          ? (_openBlock(), _createBlock(TradeCardGP, { key: 1 }))
                          : _createCommentVNode("", true)
                    ], 64))
                  : (_openBlock(), _createBlock(TradeCardGP, { key: 1 }))
              ], 64))
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(TradeSmartRouter)
        ])
      ])
    ])
  ]))
}
}

})